import { render, staticRenderFns } from "./associationList.vue?vue&type=template&id=396bb042&scoped=true"
import script from "./associationList.vue?vue&type=script&lang=js"
export * from "./associationList.vue?vue&type=script&lang=js"
import style0 from "./associationList.vue?vue&type=style&index=0&id=396bb042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396bb042",
  null
  
)

export default component.exports